/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, bool, array, func } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import {
  INVITE_COLLEAGUE_SUCCESS,
  INVITE_COLLEAGUE_FAILURE,
  inviteColleague as inviteColleagueAction,
} from 'actions/invite';

import StepHeader from 'components/StepHeader/StepHeader';
import Form from 'components/Form/Form';

import styles from './invite-colleague.scss';

/**
 * This is the InviteColleague component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class InviteColleague extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    inviteForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    inviteColleague: func.isRequired,
  };

  /**
   * Create InviteColleague.
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      inviteSent: false,
    };
  }

  onSubmit = data => {
    const { auth: { token }, inviteColleague } = this.props;

    inviteColleague(token, data).then(({ type, payload }) => {
      if (type === INVITE_COLLEAGUE_SUCCESS) {
        this.setState({
          inviteSent: true,
        });
      }

      if (type === INVITE_COLLEAGUE_FAILURE) {
        console.log('ERROR', payload); // @TODO: Handle error.
      }
    });
  };

  renderContent() {
    const { inviteSent } = this.state;
    const { inviteForm } = this.props;

    if (inviteSent) {
      return (
        <div className={styles.content}>
          <StepHeader
            tagline={p.t('invite.colleague.thank_you.tagline')}
            title={p.t('invite.colleague.thank_you.title')}
            current={2}
            total={2}
          />
        </div>
      );
    }

    return (
      <div className={styles.content}>
        <StepHeader
          title={p.t('invite.colleague.title')}
          current={1}
          total={2}
        />
        <Form {...inviteForm} onSubmit={this.onSubmit} />
      </div>
    );
  }

  /**
   * Render InviteColleague.
   *
   * @return {Object}
   */
  render() {
    return (
      <article className={styles.wrapper}>
        <div className={styles.row}>{this.renderContent()}</div>
      </article>
    );
  }
}

export default connect(({ auth, inviteForm }) => ({ auth, inviteForm }), {
  inviteColleague: inviteColleagueAction,
})(InviteColleague);
